export const isProjectObserver = (userId, projectUsers, isManagerOrAdmin = false) => {
  if (!userId) return false;

  return Boolean(
    isManagerOrAdmin ||
    (projectUsers?.author && userId === projectUsers.author.id) ||
    (projectUsers?.owner && userId === projectUsers.owner.id) ||
    (projectUsers?.observer || []).filter(Boolean).find((o) => o.id === userId)
  );
};
